import util from '../lib/util';
import newHRTimestamp from '../lib/picos/timestamp';
import type {uuid, SchemaField, EntitySchema} from "../@types/schema";
import Base from "./base";
import {genUUID} from "../lib/picos/uuids";
import type {EntityType} from "../@types/entity";
function getCurrentUserId() { return sessionStorage.getItem('userId'); }
function getCurrentFirmId() { return sessionStorage.getItem('firmId'); }
class CourtDeadlineRule extends Base implements EntityType {
    courtDeadlineRuleId: uuid;
    courtId: uuid;
    deadlineRuleId: uuid;
    sortOrder?: number | null;
    constructor(doc: typeof CourtDeadlineRule | any) {
        super(doc);
        if (!doc) doc = {
            firmId: getCurrentFirmId(),
            addedBy: getCurrentUserId(),
            addedOn: newHRTimestamp(),
            status: "C",
            entityId: null,
            entityType: null,
            courtDeadlineRuleId: genUUID(),
            courtId: null,
            deadlineRuleId: null,
        };
        // @ts-ignore
        this.entityId = doc._entityId || doc.entityId || doc.entityid || '00000000-0000-0000-0000-000000000000';
        // @ts-ignore
        this.entityType = doc._entityType || doc.entityType || doc.entitytype || "courtDeadlineRule";
        // @ts-ignore
        this.courtDeadlineRuleId = doc._courtDeadlineRuleId || doc.courtDeadlineRuleId || doc.courtdeadlineruleid || genUUID();
        // @ts-ignore
        this.courtId = doc._courtId || doc.courtId || doc.courtid || null;
        // @ts-ignore
        this.deadlineRuleId = doc._deadlineRuleId || doc.deadlineRuleId || doc.deadlineruleid || null;
        // @ts-ignore
        this.sortOrder = util.coalesce(util.parseInt(doc._sortOrder), util.parseInt(doc.sortOrder), util.parseInt(doc.sortorder), null);
    }
    get id(): uuid { return this.courtDeadlineRuleId; }
    static override getPkFields(): SchemaField[] { return [{"type":"uuid","required":true,"pk":true,"default":"__UUID__","comment":"Unique id for this court-deadline-rule link"},{"type":"uuid","required":true,"pk":true,"base":true,"default":"__FIRM__","mergeStrategy":"immutable","comment":"Associated firm"}]; }
    toLowerCase() { return this.courtDeadlineRuleId; }
    static override getNonRefArrayFields(): string[] { return []; }
    static override getDefaultEntries(): CourtDeadlineRule[] {
        return [];
    }
    static override getSchema(): EntitySchema {
        return Base.withBaseFields({
    entity: 'courtDeadlineRule',
    table: 'COURT_DEADLINE_RULE',
    comment: 'Associates a specific deadline rule template with a court, forming the many-to-many assignment of which deadline rules apply when a case is filed in that court. Stores a sortOrder to control display ordering of rules within the court.',
    fields: {
        courtDeadlineRuleId: {
            type: 'uuid',
            required: true,
            pk: true,
            default: '__UUID__',
            comment: 'Unique id for this court-deadline-rule link'
        },

        /**
         * The court this link belongs to
         */
        courtId: {
            type: 'uuid',
            required: true,
            entityType: 'court',
            deleteStrategy: 'delete', // Cascade-delete junction when court is deleted
            comment: 'The court this link belongs to'
        },

        /**
         * The deadline rule this link belongs to
         */
        deadlineRuleId: {
            type: 'uuid',
            required: true,
            entityType: 'deadlineRule',
            deleteStrategy: 'delete', // Cascade-delete junction when deadline rule is deleted
            comment: 'The deadline rule this link belongs to'
        },

        /**
         * Display order of this rule within a court
         */
        sortOrder: {
            type: 'int',
            comment: 'Display order of this rule within a court'
        }
    },
    indexes: [
        {name: 'notDeleted', fn: s => s.status !== 'D'}
    ],
    maps: [
        {
            name: 'courtId',
            keysFn: s => s.courtId,
            presentFn: (s, k) => s.courtId === k && s.status !== 'D'
        },
        {
            name: 'deadlineRuleId',
            keysFn: s => s.deadlineRuleId,
            presentFn: (s, k) => s.deadlineRuleId === k && s.status !== 'D'
        }
    ]
});
    }
}
export default CourtDeadlineRule;
